import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { RecordedSave } from "@/admin/Recorded";
import { Btn } from "@/admin/AdminLayout";
import { Field, inputCls } from "@/components/common";

const TEXT: [string, string][] = [["account_name", "Account name"], ["bank_name", "Bank"], ["bsb", "BSB"], ["account_number", "Account number"], ["swift", "SWIFT / BIC (for international transfers)"], ["notify_email", "Email me new bank transfer orders at"]];

export function BankSettings() {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState<any>(null);
  useEffect(() => { if (open) api.get("/admin-x/bank-transfer").then((r) => setF(r.data)); }, [open]);
  const save = async () => {
    try { await api.put("/admin-x/bank-transfer", { ...f, min_total: Number(f.min_total) }); toast("Bank transfer settings saved"); return true; } catch (e) { toast.error(errMsg(e)); return false; }
  };
  return (
    <>
      <Btn ghost onClick={() => setOpen(true)} data-testid="bank-settings-button">Bank transfer settings</Btn>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white max-w-lg max-h-[90vh] overflow-y-auto" data-testid="bank-settings-dialog">
          <DialogTitle className="font-display text-2xl">Bank transfer</DialogTitle>
          {f && (
            <div className="space-y-4">
              <label className="flex items-center gap-3 text-sm"><input type="checkbox" checked={f.enabled} onChange={(e) => setF({ ...f, enabled: e.target.checked })} data-testid="bank-setting-enabled" />Offer bank transfer at checkout</label>
              <Field label="Minimum order (A$)"><input type="number" min="0" value={f.min_total} onChange={(e) => setF({ ...f, min_total: e.target.value })} className={inputCls} data-testid="bank-setting-min_total" /></Field>
              {TEXT.map(([k, l]) => <Field key={k} label={l}><input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={inputCls} data-testid={`bank-setting-${k}`} /></Field>)}
              <Field label="Extra instructions (shown to the customer)"><textarea rows={2} value={f.notes || ""} onChange={(e) => setF({ ...f, notes: e.target.value })} className={inputCls} data-testid="bank-setting-notes" /></Field>
              <p className="text-xs text-neutral-500">Customers see these details after placing an order and by email. Mark each order as paid once the money arrives — that confirms it and sends the order confirmation.</p>
              <RecordedSave res="settings" id="bank_transfer" onSave={save} value={f} testId="bank-settings-save" onRestored={() => api.get("/admin-x/bank-transfer").then((r) => setF(r.data))} />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
